import { render, staticRenderFns } from "./IncomeAnalysis.vue?vue&type=template&id=29b1167e&scoped=true"
import script from "./IncomeAnalysis.vue?vue&type=script&lang=js"
export * from "./IncomeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./IncomeAnalysis.vue?vue&type=style&index=0&id=29b1167e&prod&lang=scss&scoped=true"
import style1 from "./IncomeAnalysis.vue?vue&type=style&index=1&id=29b1167e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1167e",
  null
  
)

export default component.exports